import React, { useEffect, useState, useContext } from "react";
import classnames from "classnames";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import BulkSet from "./components/bulk-set";
import TaskNav from "../../components/task-nav/task-nav";
import { WorkflowTaskList } from "./components/workflow-task-list";
import { SECTION_MAP } from "../../components/task-list/lib/constants";
import { useLocations } from "components/search-advanced-filters/hooks/use-locations";
import { useGetAssignmentOptions } from "shared/hooks/api/use-get-assignment-options";
import { useAvailableUserAssignments } from "../../shared/hooks/api/use-available-user-assignments";
import { createUniqueUsers } from "./lib/helpers";
import { PRIORITY_LEVELS } from "./lib/constants";
import "./assignment.scss";

const PERSISTED_FILTER = [{ id: "state", value: "active" }];

export const WorkflowIndex = () => {
    const { viewOnlyAdmin } = useContext(ViewOnlyPermissionsContext);
    const [pulse, setPulse] = useState(false);
    const [clearFilters, setClearFilters] = useState(false);
    const [selected, setSelected] = useState([]);
    //Default to duplicate stage since it's the only task
    const [taskType, setTaskType] = useState("duplicatestaging");
    const [state, setState] = useState({
        assignments: [],
        locations: [],
        priorityLevels: [],
        isLoaded: false,
    });
    const [usersWithAssignments, setUsersWithAssignments] = useState([]);
    const [teamFilter, setTeamFilter] = useState("");
    const [appendSettings, setAppendSettings] = useState({
        filtered: [...PERSISTED_FILTER],
    });
    const { data: locations, isSuccess: locationsLoaded } = useLocations();
    const { data: assignments, isSuccess: assignmentsLoaded } = useGetAssignmentOptions();
    const { data: availableUserAssignments, isSuccess } = useAvailableUserAssignments();

    useEffect(() => {
        if (locationsLoaded && assignmentsLoaded) {
            setState({
                ...state,
                assignments,
                locations,
                priorityLevels: PRIORITY_LEVELS,
                isLoaded: true,
            });
        }
    }, [locations, locationsLoaded, assignments, assignmentsLoaded]);

    useEffect(() => {
        if (isSuccess && availableUserAssignments.length) {
            setUsersWithAssignments(createUniqueUsers(availableUserAssignments, teamFilter));
        }
    }, [isSuccess, teamFilter, availableUserAssignments.length]);

    const updateTaskType = (value) => {
        setSelected([]);
        setTaskType(value);
        setClearFilters(!clearFilters);

        setAppendSettings({
            page: 1,
            sorted: [{ id: "due", desc: false }],
            filtered: [{ id: "taskType", value: value }, ...PERSISTED_FILTER],
        });
    };

    const setSelectedProducts = (values) => {
        setSelected(values);
    };

    const triggerTableReset = () => {
        setSelected([]);
        setPulse(!pulse);
    };

    if (!state.isLoaded) {
        return null;
    }

    const taskTypeButtons = Object.keys(SECTION_MAP).reduce((arr, key) => {
        if (key === "duplicatestaging") {
            arr.push(
                <button
                    key={`button_${key}`}
                    className={classnames("button", { "-primary": taskType === key })}
                    onClick={() => {
                        updateTaskType(key);
                    }}
                >
                    {SECTION_MAP[key].label || ""}
                </button>
            );
        }

        return arr;
    }, []);

    return (
        <div>
            <TaskNav>
                <div className="container">
                    <h1>Pre-Task Workflows</h1>
                    <BulkSet
                        taskType={taskType}
                        priorityLevels={state.priorityLevels}
                        availableUserAssignments={availableUserAssignments}
                        assignments={state.assignments}
                        selected={selected}
                        updateTaskType={updateTaskType}
                        triggerTableReset={triggerTableReset}
                        disableNotes={viewOnlyAdmin.createAssignmentNote}
                        disableTeamAssignment={viewOnlyAdmin.assignToTeam}
                        disableUserAssignment={viewOnlyAdmin.assignToUser}
                    />
                </div>
            </TaskNav>

            <div className="task-type-buttons button-group flex-wrap">{taskTypeButtons}</div>

            {taskType && (
                <WorkflowTaskList
                    taskType={taskType}
                    usersWithAssignments={usersWithAssignments}
                    appendSettings={appendSettings}
                    assignments={state.assignments}
                    locations={state.locations}
                    priorityLevels={state.priorityLevels}
                    setSelectedProducts={setSelectedProducts}
                    selected={selected}
                    updatePulse={pulse}
                    clearFilters={clearFilters}
                    statuses={[]}
                    setTeamFilter={setTeamFilter}
                    disableNotes={viewOnlyAdmin.createAssignmentNote}
                />
            )}
            {!taskType && <h1 className="txt-center">Please select a task type</h1>}
        </div>
    );
};
